export default "__VITE_ASSET__CJ5vbZ01__"